(ns ncr.fragment.share-send
  (:require
   [cljs.core.async :refer-macros [go]]
   [lambdaisland.glogi :as log]
   [uix.core.alpha :as uix]
   [ncr.me :as me]
   [ncr.widgets.domain :as wdom]
   [ncr.etc.pf :as pf]
   [ncr.etc.util :as u]
   [ncr.etc.rhf :as rhf]
   [ncr.etc.modal :as m]
   [ncr.etc.alert :as a]
   [ncr.etc.pubsub :as ps]
   [ncr.backend :as b]))

(defn- c-send-dialog [me fragments]
  (let
    [singleton (u/singleton fragments)
     modal-id :send-to-user-modal
     ref (uix/ref)

     {:keys [submit] :as form}
     (rhf/use-form
       {:should-focus-error false})]

    (m/use-submit-form modal-id ref submit)

    [m/c-modal
     {:title
      (if (some? singleton)
        "Send Fragment to"
        (u/format "Send %d Fragments to" (count fragments)))
      :variant :small
      :id modal-id
      :ref ref
      :is-overflow-visible true
      :actions
      [[pf/c-button
        {:variant :primary
         :on-click submit}
        "Ok"]
       [pf/c-button
        {:variant :link :on-click #(m/close! nil)}
        "Cancel"]]}
     [pf/c-form {:on-submit submit}
      (let [id (uix/memo #(gensym) [])]
        [rhf/c-form-group {:label "User" :field-id id} :user form
         [wdom/c-user-selector
          {:id id
           :name :user
           :form form
           :rules {:required true}
           :filter-fn
           (let [self (get me :id)]
             (fn [{:keys [id]}]
               (not= self id)))}]])]]))

(defn- !send-to [me fragments user]
  (let
    [{user-name :name} (me/user-by-id me user)]
    (a/!fragment-operation
      {:operation-title
       (u/format "Sending to %s" user-name)
       :success-title (u/format "Sent to %s" user-name)
       :fragments fragments}

      (b/!multi-mutation
        (map
          (fn [{:keys [id]}]
            [id
             [:reference_send
              {:id id
               :user user}]])
          fragments)))))

(defn !send [me fragments]
  (go
    (if-let [{:keys [user]} (<! (m/!modal #'c-send-dialog me fragments))]
      (when (<! (!send-to me fragments user))
        (ps/pub! [:me/load]))
      [:error :cancel])))
